import {RestApiService} from '../../../rest-api.service';
import {
    AcquisitionTrackerCreateReq,
    AcquisitionTrackerRes,
    ToDoTrackerCreateReq,
    TodoTrackerDetailRes,
    TrackerAdvanceReq,
    TrackerCreateReq,
    TrackerDetailRes
} from '../../../../contracts/v0/crm';
import {Observable} from 'rxjs';
import {ApiV0Crm} from '../api.v0.crm';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0CrmTracker {
    segment = '/tracker';

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }


    search(searchModel?: SearchModel) {
        return this.rest.post<SearchModel, BaseCollectionModel<AcquisitionTrackerRes>>(
            `${this.segment}/search`,
            AcquisitionTrackerRes,
            searchModel)
    }

    createProduct(createReq: AcquisitionTrackerCreateReq) {
        return this.rest.post<TrackerCreateReq, TrackerDetailRes>(`${this.segment}/product`, AcquisitionTrackerRes, createReq)
    }

    createToDo(createReq: ToDoTrackerCreateReq) {
        return this.rest.post<TrackerCreateReq, TrackerDetailRes>(`${this.segment}/todo`, TodoTrackerDetailRes, createReq)
    }

    advance(advanceReq: TrackerAdvanceReq): Observable<TrackerDetailRes> {
        return this.rest.post<TrackerAdvanceReq, TrackerDetailRes>(`${this.segment}/advance`, TrackerDetailRes, advanceReq)
    }

    deactivate(tracker: TrackerDetailRes) {
        return this.rest.delete<TrackerDetailRes>(`${this.segment}/deactivate/${tracker.id}`)
    }

    getForCompany(id:number){
        return this.rest.get<BaseCollectionModel<TrackerDetailRes>>(`${this.segment}/forCompany/${id}`)
    }
}
